module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d00ebbc2cedcaa3856c0652479cd2bc0.png";